import React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { withRouter, RouteComponentProps } from 'react-router-dom'

import { routes } from 'routes/RouterStackComponent'
import CreateProfile from 'views/CreateProfile/CreateProfile'
import VerifyEmail from 'views/VerifyEmail/VerifyEmail'
import { asyncCompleteOnboarding, selectCurrentUser, VerificationStatus } from 'store/services/User'
import { AppState } from 'store/types'
import { asyncGetAllBooks, asyncGetBooksProgress } from 'store/services/Book'
import { asyncGetStudyTime, getLibrary } from 'store/services/Library'
import { GACategory, GAEvent, trackEvent } from 'utils/analytics'

const onboardingBookWrapperStyling: React.CSSProperties = {
  flex: '1 0 auto',
  display: 'flex'
}

interface IState {
  loading: boolean
}

interface IProps extends RouteComponentProps, ConnectedProps<typeof connector> {
  children: React.ReactNode
}

class ProfileWall extends React.Component<IProps, IState> {
  readonly state: IState = {
    loading: false
  }

  // async componentDidMount() {
  //   const { asyncGetAllBooks, asyncGetStudyTime, getLibrary, asyncGetBooksProgress } = this.props

  //   if (this.props.user?.profile) {
  //     await asyncGetAllBooks()
  //     await asyncGetBooksProgress()
  //     await asyncGetStudyTime(Intl.DateTimeFormat().resolvedOptions().timeZone)
  //     await getLibrary()
  //   }
  //   this.setState({ loading: false })
  // }

  onOnboardingBookFinish = async () => {
    await this.props.asyncCompleteOnboarding()
    trackEvent({
      event: GAEvent.FINISH_ONBOARDING,
      category: GACategory.USER,
      label: 'Onboarding book finish'
    })
    this.props.history.replace(routes.onboarding_finished)
  }

  render() {
    const { loading } = this.state
    const { user } = this.props

    if (loading) {
      return null
    } else if (!user?.profile) {
      return <CreateProfile />
    } else if (user.verificationStatus === VerificationStatus.NOT_VERIFIED) {
      return <VerifyEmail />
    } else if (user && !user?.onboardingCompleted) {
      return this.props.children
      // <div style={onboardingBookWrapperStyling}>
      //   <OnboardingBook
      //     onMount={() => {
      //       GA_event({
      //         category: GAEventCategory.USER,
      //         action: GAEventActions.START_ONBOARDING,
      //         label: 'Onboarding book start'
      //       })
      //     }}
      //     country={user.profile?.country}
      //     getAstridScore={astridGetScore}
      //     onFinish={this.onOnboardingBookFinish}
      //   />
      // </div>
    } else {
      return this.props.children
    }
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    user: selectCurrentUser(state)
  }
}

const connector = connect(mapStateToProps, {
  asyncGetAllBooks,
  asyncGetStudyTime,
  getLibrary,
  asyncGetBooksProgress,
  asyncCompleteOnboarding
})

export default connector(withRouter(ProfileWall))
